import "./Dropdown.css";
import { useEffect, useRef, useState } from "react";
import Description from "../Description/Description";

const Dropdown = ({
  currentModel,
  setCurrentModel,
  models,
  setCurrentModelDescription,
  currentModelDescription,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (model) => {
    setCurrentModel(model.id);
    setCurrentModelDescription(model.description);

    setIsOpen(false);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className="dropdown">
      <div
        className="dropdown-header"
        value={currentModel}
        onClick={toggleDropdown}
      >
        {currentModel || "Select a model"}{" "}
        <span className="dropdown-arrow">{isOpen ? "⌃" : "⌄"}</span>
      </div>
      {isOpen && (
        <ul className="dropdown-list">
          {models.map((model, index) => (
            <li
              className="list-model"
              key={index}
              value={model.id}
              onClick={() => handleOptionClick(model)}
            >
              {model.id}
            </li>
          ))}
        </ul>
      )}

      {!isOpen && (
        <Description currentModelDescription={currentModelDescription} />
      )}
    </div>
  );
};

export default Dropdown;
